export default "__VITE_ASSET__87acc51f__"